<template>

    <Toast/>

    <MenuHealthCompact/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Admin Interface</a></li>
                    </ul>

                    <h3>Admin Interface</h3>

                    <div style="height: 0.5rem;"></div>

                    <h4>Manage Health Insurance Rates</h4>

                    <div class="p-field">
<!--                        <input type="file" @change="handleFileUploadClientImport" accept=".csv"/>-->

                        <input
                            type="file"
                            ref="fileInputClientImport"
                            @change="handleFileUploadClientImport"
                            accept=".csv"
                        />
                    </div>



                    <br/>

                    <div class="p-field">
                        <Button label="Import" :loading="submitted" class="mr-2 mb-2" :disabled="!fileClientImport"
                                @click="submitFileClientImport"></Button>
                    </div>


                    <div style="height: 2rem;"></div>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import axios from "axios";

export default {
    components: {
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            fileClientImport: null,
            submitted: false,
            companyConfiguration: {},
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                try {
                    // Attempt to get user data
                    const userData = await UserService.getUser(this.userStore.user.id);
                    this.profile = userData.data;
                } catch (e) {
                    console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                    this.userStore.clearUser();
                    this.$router.push('login');
                    return;
                }

                this.profile.companyId = this.userStore.activeCompanyId;

            } catch (e) {
                console.error("[ProfileAccount][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
            }
        },
        handleFileUploadClientImport(event) {
            this.fileClientImport = event.target.files[0];
        },
        async submitFileClientImport() {
            this.submitted = true;

            if (!this.fileClientImport) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
            }

            const formData = new FormData();
            formData.append('file', this.fileClientImport);

            var url = "/api/providercomponent/upload/generic/comma";

            try {
                const response = await axios.post(url, formData, {
                    headers: {
                        'Authorization': `Bearer ${this.userStore.accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                console.log('[ProfileAdmin][submitFile] Upload successful = ', response.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Uploaded health insurance rates',
                    life: 3000
                });

            } catch (error) {
                console.error('Error uploading file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Upload of health insurance rates NOT successful',
                    life: 3000
                });
            }

            this.fileClientImport = null;
            this.$refs.fileInputClientImport.value = null;
            this.submitted = false;
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return numeral(String(0)).format('0,0.00');
            }
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
